<template>
  <div class="my_edit_item my_color_layer">
    <div v-if="is_page_background" class="color-cube-wrapper">
      <div class="title">背景颜色</div>
      <div class="color-cube color-cube-main" :style="{ background: my_color }" @click="picker_open"></div>
      <div class="quick-panel">
        <div class="row-color row-1">
          <div
            v-for="(color, index) in quick_color_config.slice(0,5)"
            :key="index"
            :class="['quick-cube', 'quick-cube-'+index]"
            @click="on_click_quick_color(color)"></div>
        </div>
        <div class="row-color">
          <div
            v-for="(color, index) in quick_color_config.slice(5,10)"
            :key="index"
            :class="['quick-cube', 'quick-cube-'+(index+5)]"
            @click="on_click_quick_color(color)"></div>
        </div>
      </div>
    </div>
    <div v-else class="normal-color-wrapper">
      <!-- <span v-text="title" class="title" :style="{ width: titleWidth + 'px' }"></span> -->
      <!--
        <img src="@/assets/images/change_color.png" alt=""> -->
      <span
        class="color_box"
        v-if="!svg"
        @click="picker_open"
      >
      <span
        :class="my_color === 'rgba(254,254,254,0)' ? 'color_block_transparent' : ''"
          class="color_block"
          :style="{ background: my_color,'border-radius':'4px 0px 0px 4px' }"></span>
        <img src="@/assets/images/change_color.png" alt="">
      </span>
      <span
          v-else
          class="color_block"
          :class="my_color === 'rgba(254,254,254,0)' ? 'color_block_transparent' : ''"
          @click="picker_open"
          style="display: flex; align-items: center; justify-content: center"
      >
        <svg-icon icon-class="color" />
      </span>
      <!-- <span v-text="title" class="title" :style="{ width: titleWidth + 'px' }"></span> -->
    </div>
  </div>
</template>

<script>
/*
* linear_gradient 文字渐变对象
* color纯色色值
* title组件标题
*pattern pure_color 纯色   linear_gradient 渐变
* */

export default {
  name: 'MyColor',
  props: {
    svg: {
      type: Boolean,
      default: false
    },
    titleWidth: {
      type: String,
      default: '60'
    },
    color: {
      type: String,
      default: 'rgb(255, 255, 255,1)'
    },
    pattern: {
      type: String,
      default: 'pure_color'
    },
    linear_gradient: {
      type: Object,
      default: function() {
        return {}
      }
    },
    title: { // 组件的标题
      type: String,
      default: '颜色'
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'one_level'
    },
    is_page_background: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      picker_is_show: false,
      my_color: this.color,
      my_Pattern: 'pure_color',
      my_linear_gradient: this.linear_gradient,
      quick_color_config: ['#ffffff', '#EB3430', '#F4B264', '#FEFD54', '#ABEE4B', '#80B336', '#46A7EA', '#B986F8', '#C7C7C7', '#000000']
    }
  },
  watch: {
    color(val) {
      if (!val || val === 'transparent') {
        this.my_color = 'rgba(255,255,255,0)'
      } else {
        this.my_color = val
      }
    }
  },
  components: {},
  methods: {
    hexToRgb(hex) {
      var reg = /^[0-9a-zA-Z]$/
      let r = ''
      if (!reg.test(hex) && hex.length === 6) {
        r = 'rgb(' + parseInt('0x' + hex.slice(0, 2)) + ',' + parseInt('0x' + hex.slice(2, 4)) + ',' + parseInt('0x' + hex.slice(4, 6)) + ')'
      }
      return r
    },
    picker_open(e) {
      let color = this.my_color
      if (color && color.indexOf('#') >= 0 && color.length === 4) {
        color = color.substr(1, 3)
        color = color.split('').map(c => c.concat(c)).join('')
        color = this.hexToRgb(color)
      } else if (color && color.indexOf('#') >= 0 && color.length === 7) {
        color = color.split('#')[1]
        color = this.hexToRgb(color)
      }
      this.$store.commit('color/select_color_change', color)
      this.$store.commit('color/set_Pattern', this.my_Pattern)
      this.$store.commit('color/set_linear_gradient', this.my_linear_gradient)
      this.$store.commit('color/isShow_change', true)
      this.$store.commit('color/change_edit_item', !this.$store.state.color.edit_item_changed)
      const isInDialog = this.isInDialog()
      const left = isInDialog ? (e.clientX + 30) : 'auto' // e.clientX + 15
      const top = isInDialog ? (e.clientY - 90) : (e.clientY - 60)
      const right = isInDialog ? 'auto' : 300
      const position = isInDialog ? 'fixed' : 'absolute'
      this.$nextTick(() => {
        // 颜色选择器可能显示不完整
        // const screenHeight = $(window).height()
        // const colorPickerHeight = $('.my_picker').height()
        // if ((top + colorPickerHeight + 60) > screenHeight) {
        //   top = screenHeight - colorPickerHeight - 70
        // }
        this.$store.commit('color/set_position', {
          left,
          top,
          right,
          position
        })
        this.$forceUpdate()
      })

      this.$store.commit('color/set_color_change', (data) => {
        if (data.select_color) {
          this.my_color = data.select_color
        }
        this.$emit('update:color', this.my_color)
        this.$emit('change', this.my_color)
      })
    },
    on_click_quick_color(color) {
      this.$emit('update:color', color)
      this.$emit('change', color)
    },
    setPositionNormal() {
    //   const screenHeight = $(window).height()
    //   const colorPickerHeight = $('.my_picker').height()
    //   if ((top + colorPickerHeight + 60) > screenHeight) {
    //     top = screenHeight - colorPickerHeight - 70
    //   }
    //   this.$store.commit('color/set_position', {
    //     left,
    //     top,
    //   });
    },
    setPositionInDialog() {
    //   let screenHeight = $(window).height()
    //   let colorPickerHeight = $('.my_picker').height()
    //   if ((top + colorPickerHeight + 60) > screenHeight) {
    //     top = screenHeight - colorPickerHeight - 70
    //   }
    //   this.$store.commit('color/set_position', {
    //     left,
    //     top,
    //   });
    },
    isInDialog() {
    //   let dialogs = document.querySelectorAll('.el-dialog__wrapper');
    //   return [...dialogs].some(d => {
    //     return d.style.display !== 'none'
    //   })
    }
  },
  created() {
    // 颜色可能是空字符串''
    if (!this.my_color || this.my_color === 'transparent') {
      this.my_color = 'rgba(254,254,254,0)'
    }
    // console.log('isPageBackground', this.isPageBackground)
    // console.log('is_page_background', this.is_page_background)
  }
}
</script>

<style scoped lang="scss">
.normal-color-wrapper {
  .title, .color_block {
    vertical-align: middle;
    .svg-icon {
      width: 16px;
      height: 16px;
    }
  }

  .title {
    display: block;
    // font-size: 14px;
    // margin-right: 5px;
    font-size: 10px;
    color: #333;
    text-align: center;
  }
}

.color_block {
  display: inline-block;
  box-sizing: border-box;
  // width: 46px;
  // height: 32px;
  width: 66px;
  height: 32px;
  overflow: hidden;
}
.color_box {
  display: flex;
  height: 32px;
  // margin-left: 8px;
  border-radius: 4px;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  overflow: hidden;
}

.color_block_transparent {
  position: relative;
}

.color_block_transparent::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
}

.color_block_transparent::after {
  content: "";
  position: absolute;
  top: 100%;
  left: -2px;
  transform: rotate(333deg);
  transform-origin: 0 0;
  width: 62px;
  height: 1px;
  background: red;
}

.color-cube-wrapper {
  .title {
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
  }
}
.color-cube-main {
  display: inline-block;
  width: 49px;
  height: 65px;
  background: #E39292;
  border: 1px solid #D5D5D5;
  border-radius: 4px;
  vertical-align: top;
  margin-right: 16px;
  cursor: pointer;
}

.quick-panel {
  display: inline-block;
  vertical-align: top;
}

.quick-cube {
  display: inline-block;
  width: 28px;
  height: 28px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #D5D5D5;
  vertical-align: top;
  margin-right: 8px;
  cursor: pointer;
}

.quick-cube-0 {
  background: #fff;
}

.quick-cube-1 {
  background: #EB3430;;
}

.quick-cube-2 {
  background: #F4B264;
}

.quick-cube-3 {
  background: #FEFD54;
}

.quick-cube-4 {
  background: #ABEE4B;
}

.quick-cube-5 {
  background: #80B336;
}

.quick-cube-6 {
  background: #46A7EA;
}

.quick-cube-7 {
  background: #B986F8;
}

.quick-cube-8 {
  background: #C7C7C7;
}

.quick-cube-9 {
  background: #000000;
}

.row-color.row-1 {
  margin-bottom: 9px;
}

</style>
